import React from 'react';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';

const CrmCheckBoxField = (props) => {
  const { name, label, value, onChange, disabled, tooltip = '' } = props;

  const checkboxControl = (
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          name={name}
          disabled={disabled}
          checked={value}
          onChange={onChange}
        />
      }
      label={label}
    />
  );
  return tooltip ? (
    <Tooltip
      title={tooltip}
      arrow
      placement="top"
      disableFocusListener={false}
      disableHoverListener={false}
      disableTouchListener={true}
      enterTouchDelay={0}
    >
      {checkboxControl}
    </Tooltip>
  ) : (
    checkboxControl
  );
};

export default CrmCheckBoxField;
